
import * as reducer from './reducers';

import * as projectDetailsTypes from './types';
import * as projectDetailsActions from './actions';
import * as projectDetailsEpics from './epics';
import * as projectDetailsSelectors from './selectors';

export { projectDetailsTypes, projectDetailsActions, projectDetailsEpics, projectDetailsSelectors };

export default reducer;

